<template>
  <section>
    <v-server-table
      :columns="columns"
      :options="tableOptions"
      @row-click="onRowClicked"
      ref="requestsTable"
      id="requestsTable"
    >
    <span slot="status" slot-scope="{row}">
      <span :title="$t('entityrequests.status.pending')" v-if="row.status == 0">
        <i class="fa fa-clock-o"></i>&nbsp;&nbsp;{{$t('entityrequests.status.pending')}}
      </span>
      <span :title="$t('entityrequests.status.created')" v-if="row.status == 1">
        <i class="fa fa-check"></i>&nbsp;{{$t('entityrequests.status.created')}}
      </span>
    </span>
    <span slot="kiosk_interest" slot-scope="{row}">
      <span :title="$t('entityrequests.inputs.kiosk_interest')" v-if="row.kiosk_interest">
        <i class="fa fa-check"></i>&nbsp;
      </span>
      <span :title="$t('entityrequests.kiosk_pricing')" v-if="row.kiosk_pricing">
        <i class="fa fa-television"></i>&nbsp;
      </span>
      <span :title="$t('entityrequests.portable_pricing')" v-if="row.portable_pricing">
        <i class="fa fa-tablet"></i>&nbsp;
      </span>
    </span>
    <span slot="business_plan" slot-scope="{row}">
      <span v-if="row.business_plan_id && getBusinessPlanById(row.business_plan_id)">
        {{getBusinessPlanById(row.business_plan_id).name}}
      </span>
    </span>
    <span slot="created_at" slot-scope="{row}">
      <span>
        {{row.created_at | localTime('YYYY/MM/DD HH:mm')}}
      </span>
    </span>
    <span slot="created_by" slot-scope="{row}">
      <span v-if="row.creator_entity.id == 1">
        {{ row.creator_entity.name }}
      </span>
      <span v-else>
        {{ row.created_by ? row.created_by.name : '' }}
      </span>
    </span>

    </v-server-table>

    <ShowEntityRequestModal
      v-if="isShowingEntityRequest && selectedEntityRequest != null"
      :entityRequest="selectedEntityRequest"
      :businessPlans="businessPlans"
      :weekDays="weekDays"
      :userProfile="userProfile"
      @entity-request-updated="onEntityRequestUpdated"
      @cancel="onCloseShowEntityRequestModal"
      @deleteEntityRequest ="onDeleteEntityRequest"
      @entityCreated = "onEntityCreated"
    >
    </ShowEntityRequestModal>
  </section>
</template>
<script>
import ShowEntityRequestModal from '@/components/entityrequests/ShowEntityRequestModal'
import TableQueryMixin from '@/mixins/TableQueryMixin'
export default {
  props: {
    querySearch: {
      type: String,
      required: false
    },
    businessPlans: {
      type: Array,
      required: false
    },
    weekDays: {
      type: Array,
      required: false
    },
    userProfile: {
      type: Object,
      required: true
    }
  },
  components: {
    ShowEntityRequestModal
  },
  mixins: [
    TableQueryMixin
  ],
  mounted: function () {
    console.log(this.$store.state.services, this.$store.state.evollead_server)
  },
  data: function () {
    return {
      columns: ['entity_name', 'status', 'kiosk_interest', 'business_plan', 'created_by', 'created_at'],
      queryUrl: `${this.$store.state.evollead_server}/entityrequest`,
      tableOptions: {
        columnsDropdown: false,
        saveState: false,
        sortable: ['entity_name', 'status', 'kiosk_interest', 'created_by', 'created_at'],
        columnsClasses: {
          entity_name: 'entity_name',
          status: 'status',
          kiosk_interest: 'kiosk_interest',
          created_by: 'created_by',
          created_at: 'created_at',
        },
        headings: {
          entity_name: this.$t('entityrequests.inputs.entity_name'),
          status: this.$t('entityrequests.inputs.status'),
          kiosk_interest: this.$t('entityrequests.inputs.kiosk_interest'),
          created_by: this.$t('entityrequests.inputs.created_by'),
          business_plan: this.$t('entityrequests.inputs.business_plan'),
          created_at: this.$t('entityrequests.inputs.created_at')
        }
      },
      isShowingEntityRequest: false,
      selectedEntityRequest: null
    }
  },
  methods: {
    refresh: function () {
      this.$refs.requestsTable.refresh()
    },
    onRowClicked: function ({ row }) {
      this.selectedEntityRequest = row
      this.isShowingEntityRequest = true
    },
    getBusinessPlanById: function (id) {
      return this.businessPlans.find(businessPlan => businessPlan.id === id)
    },
    onCloseShowEntityRequestModal: function () {
      this.selectedEntityRequest = null
      this.isShowingEntityRequest = false
    },
    onEntityRequestUpdated: function ({ entityRequest }) {
      this.selectedEntityRequest = entityRequest
    },
    reopenDetails: function (entityRequest) {
      this.selectedEntityRequest = entityRequest
      setTimeout(() => { this.isShowingEntityRequest = true }, 500)
    },
    onDeleteEntityRequest: function (entityRequest) {
      this.isShowingEntityRequest = false
      this.$emit('deleteEntityRequest', entityRequest)
    },
    onEntityCreated: function () {
      this.isShowingEntityRequest = false
      this.refresh()
    }
  },
  watch: {
    querySearch: function (value) {
      this.$refs.requestsTable.setFilter(value)
    }
  }
}
</script>
